document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const addToCartBtn = form.querySelector('[name="add"]');
  const selects = form.querySelectorAll('select[name="id"], fieldset input[type="radio"]');

  if (!addToCartBtn || selects.length === 0) return;

  // Disable button on load
  addToCartBtn.disabled = true;
  addToCartBtn.style.opacity = '0.5';

  // Add message
  const msg = document.createElement('p');
  msg.id = 'variant-required-msg';
  msg.textContent = 'Please select your options before adding to cart.';
  msg.style.color = 'red';
  msg.style.fontSize = '0.9em';
  addToCartBtn.parentNode.insertBefore(msg, addToCartBtn);

  form.addEventListener('change', function () {
    const allSelected = [...form.querySelectorAll('fieldset')]
      .every(fs => fs.querySelector('input[type="radio"]:checked'));
    addToCartBtn.disabled = !allSelected;
    addToCartBtn.style.opacity = allSelected ? '1' : '0.5';
    msg.style.display = allSelected ? 'none' : 'block';
  });
});
